const map = {
	"./campuslm1.png": 935,
	"./campuslm2.png": 444,
	"./campuslm3.png": 506,
	"./campuslm4.png": 226,
	"./mooslixmobile1.png": 526,
	"./tarragon1.png": 307,
	"./tarragon2.png": 744,
	"./tarragon3.png": 945
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 969;